import { render, staticRenderFns } from "./ClassificationList.vue?vue&type=template&id=bf68cdb4&"
import script from "./ClassificationList.vue?vue&type=script&lang=js&"
export * from "./ClassificationList.vue?vue&type=script&lang=js&"
import style0 from "./ClassificationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf68cdb4')) {
      api.createRecord('bf68cdb4', component.options)
    } else {
      api.reload('bf68cdb4', component.options)
    }
    module.hot.accept("./ClassificationList.vue?vue&type=template&id=bf68cdb4&", function () {
      api.rerender('bf68cdb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/components/wizard/companies/60100003-2/components/ClassificationList.vue"
export default component.exports